import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './assets/iconfont/iconfont.css';
import Router from './router/Router';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import { Store } from './reducers';

declare global {
  var user: {
    id: string;
    login: boolean;
    fsLogo: string;
    fsBackground: string;
    spaceLogo: string;
  };
  interface EScreen {
    id: string;
    url: string;
    image: string;
    width: number;
    height: number;
  }
}

const store = createStore(Store, applyMiddleware(thunkMiddleware));

const id = window.location.pathname.split('/')[1];

const App = function() {
  return (
    <Provider store={store}>
      <Router id={id} />
    </Provider>
  );
};
ReactDOM.render(<App />, document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
